import { render } from "./groupdetail.html?vue&type=template&id=27059e72&scoped=true&external"
import script from "./groupdetail.ts?vue&type=script&lang=js&external"
export * from "./groupdetail.ts?vue&type=script&lang=js&external"

import "./groupdetail.scss?vue&type=style&index=0&id=27059e72&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27059e72"],['__file',"src/view/group/groupdetail/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27059e72"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27059e72', __exports__)) {
    api.reload('27059e72', __exports__)
  }
  
  module.hot.accept("./groupdetail.html?vue&type=template&id=27059e72&scoped=true&external", () => {
    api.rerender('27059e72', render)
  })

}


export default __exports__